module.exports = __webpack_public_path__ + "static/media/Chapter 3 Slide 5.bd446695.jpg";